// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "html,\r\nbody{\r\n    width: 100%;\r\n    overflow-x: hidden !important;\r\n}", "",{"version":3,"sources":["assets/styles/global/global.scss"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,6BAA6B;AACjC","file":"styles.css","sourcesContent":["html,\r\nbody{\r\n    width: 100%;\r\n    overflow-x: hidden !important;\r\n}"]}]);
// Exports
module.exports = exports;
